import { render, staticRenderFns } from "./new-registered-coach.vue?vue&type=template&id=5a46809e&scoped=true&"
import script from "./new-registered-coach.vue?vue&type=script&lang=js&"
export * from "./new-registered-coach.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a46809e",
  null
  
)

export default component.exports